import { createFileRoute } from "@tanstack/react-router"
import { WhatsappTemplates } from "modules/campaigns/components/Sections/channels/whatsapp"
import { PaginationSearchSchema } from "modules/shared/hooks/usePagination"
import { SearchQuerySchema } from "modules/shared/hooks/useSearchQuery"
import { WhatsappTemplatesFilterBySchema, WhatsappTemplatesSortSchema } from "schema"
import { z } from "zod"

// eslint-disable-next-line react-refresh/only-export-components
export const SearchSchema = PaginationSearchSchema.merge(SearchQuerySchema)
  .merge(WhatsappTemplatesSortSchema.shape.sortBy.unwrap())
  .merge(WhatsappTemplatesFilterBySchema)
  .merge(z.object({ from: z.string().optional() }))

export const Route = createFileRoute("/_base/_auth/settings/channels/whatsapp/templates/")({
  component: WhatsappTemplates,
  validateSearch: (search: Partial<z.infer<typeof SearchSchema>>) => {
    search.filterBy = search.filterBy || {}
    return SearchSchema.parse(search)
  },
})
